import PropTypes from "prop-types";

const SLOT_CLASS = "min-h-[2.4em] w-full min-w-0 leading-[1.2] overflow-hidden text-ellipsis";

/**
 * @param {React.ReactNode} node
 * @returns {string}
 */
function captionPlainText(node) {
  if (node == null || node === false) {
    return "";
  }
  if (typeof node === "string" || typeof node === "number") {
    return String(node).trim();
  }
  return "";
}

/**
 * Below-media cell caption. Reserves a fixed two-line height so multi-row
 * carousel columns stay vertically aligned when labels wrap.
 *
 * Single word: one line with ellipsis — letters never wrap to a second line.
 * Multiple words: wrap only at spaces (whole words move to line 2); up to two
 * lines, then ellipsis. No breaking inside a word.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Label text.
 * @param {object} [props.style] - Typography styles (fontSize, color, textAlign, etc.).
 * @param {string} [props.wrapperClassName] - Extra classes on the outer wrapper.
 * @param {object} [props.wrapperStyle] - Inline styles on the outer wrapper.
 * @returns {React.ReactElement}
 */
const CellCaption = ({ children, style, wrapperClassName = "", wrapperStyle }) => {
  const normalized = captionPlainText(children).replace(/\s+/g, " ");
  const isSingleWord = normalized.length > 0 && !normalized.includes(" ");

  return (
    <div className={`w-full min-w-0 ${wrapperClassName}`} style={wrapperStyle}>
      <p
        className={
          isSingleWord ? `${SLOT_CLASS} truncate whitespace-nowrap` : `${SLOT_CLASS} line-clamp-2 break-normal`
        }
        style={style}
      >
        {children}
      </p>
    </div>
  );
};

CellCaption.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  wrapperClassName: PropTypes.string,
  wrapperStyle: PropTypes.object,
};

export default CellCaption;
